(function ($) {
  $.fn.countUp = function (opts) {
    var defaults = {
      duration: 1500,
      decimals: 0,
      easing: 'swing',
      formatter: function (n, decimals) {
        var v = Number(n).toFixed(decimals);
        return Number(v).toLocaleString('pl-PL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      }
    };
    var settings = $.extend({}, defaults, opts);

    return this.each(function () {
      var $el = $(this);
      var target = Number($el.data('target') || $el.text() || 0);
      var duration = Number($el.data('duration')) || settings.duration;
      var decimals = Number($el.data('decimals'));
      var start = 0;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var t = Math.min((ts - startTime) / duration, 1); // 0..1
        // jQuery easing (jeśli jest), inaczej linear
        var ease = ($.easing && $.easing[settings.easing])
          ? $.easing[settings.easing](t, duration * t, 0, 1, duration)
          : t;

        var value = start + (target - start) * ease;
        // przyrost bez migotania: zaokrąglamy wg decimals
        var pow = Math.pow(10, isNaN(decimals) ? settings.decimals : decimals);
        $el.text(settings.formatter(Math.round(value * pow) / pow, decimals));

        if (t < 1) requestAnimationFrame(step);
        else $el.text(settings.formatter(target, decimals));
      }

      requestAnimationFrame(step);
    });
  };

  function initCountups($scope) {
    var $els = ($scope || $(document)).find('.js-countup');

    if ('IntersectionObserver' in window) {
      var seen = new WeakSet();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !seen.has(e.target)) {
            $(e.target).countUp();
            seen.add(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });

      $els.each(function () { io.observe(this); });
    } else {
      // Fallback: prosty on-scroll „once”
      var fired = new WeakSet();
      function onScroll() {
        $els.each(function () {
          var el = this;
          if (fired.has(el)) return;
          var rect = el.getBoundingClientRect();
          var inView = rect.top < window.innerHeight * 0.85 && rect.bottom > 0;
          if (inView) {
            $(el).countUp();
            fired.add(el);
          }
        });
      }
      $(window).on('scroll resize', onScroll);
      onScroll();
    }
  }

  // Auto-init
  $(function () { initCountups($(document)); });

  // Eksport init, gdybyś chciał odpalać dynamicznie po ajaxie:
  window.initCountups = initCountups;
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/partials/countup.js